import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit() {

  }

  emitClose() {
    this.close.emit(true);
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/components/popup/popup.component.ts